import omni from '@/views/omni/'

export const apps =
{
    path: '/omni',
    name: 'omni',
    meta: {
        title: 'Chat',
    },
    component: omni,
}
export default apps



// WEBPACK FOOTER //
// ./src/router/modules/apps.js